// extracted by mini-css-extract-plugin
export default {"skillslist":"SkillsCartList_skillslist__w4eIX"};